import {ReactNode} from 'react';
import {
  FeatureFlags,
  FeatureFlagsProvider,
} from '@stripe-internal/conversations-ui';
import {useProfile} from './ProfileProvider/ProfileProvider';

type Props = {
  children: ReactNode;
};

export function ConversationsUIFeatureFlagsProvider({children}: Props) {
  const {profile} = useProfile();
  const {featureFlags} = profile;
  const {
    enableUniversalHelp,
    universalHelpUseNewDesign,
    universalHelpUseDotComDesign,
    universalHelpDotComFeedbackButtons,
    universalHelpDotComNoLlm,
    universalHelpDotComCsf,
    universalHelpMessagesTopAnchored,
    universalHelpUseInlineRacEmailForm,
    universalHelpDrawerEnabled,
    consolidatedConversationsLiveAnswersRow,
    universalHelpEncourageMoreDetailFromUserMse5042,
    enableScreenshareUi,
  } = featureFlags;

  const value: FeatureFlags = {
    newUniversalHelpDesign: enableUniversalHelp && universalHelpUseNewDesign,
    universalHelpDotComDesign:
      enableUniversalHelp && universalHelpUseDotComDesign,
    dotComFeedbackButtons:
      enableUniversalHelp && universalHelpDotComFeedbackButtons,
    dotComNoLlm: enableUniversalHelp && universalHelpDotComNoLlm,
    dotComCsf: enableUniversalHelp && universalHelpDotComCsf,
    messagesTopAnchored:
      enableUniversalHelp && universalHelpMessagesTopAnchored,
    inlineRacEmailForm:
      enableUniversalHelp && universalHelpUseInlineRacEmailForm,
    universalHelpDrawerEnabled:
      enableUniversalHelp && universalHelpDrawerEnabled,
    conversationsLiveAnswersRow:
      consolidatedConversationsLiveAnswersRow || universalHelpUseDotComDesign,
    universalHelpEncourageMoreDetailFromUserMse5042,
    enableScreenshareUi,
  };

  return <FeatureFlagsProvider value={value}>{children}</FeatureFlagsProvider>;
}
